import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PreorderListModel} from '../../../../shared/services/preorder/preorderList.model';

@Component({
  selector: 'app-preorder-overview-table',
  templateUrl: './preorder-overview-table.component.html',
  styleUrls: ['./preorder-overview-table.component.scss']
})
export class PreorderOverviewTableComponent {
  @Input() preorders: PreorderListModel[];

  @Output() openDetails = new EventEmitter<string>();

  constructor() { }

  onOpenDetails(reference: string) {
    this.openDetails.emit(reference);
  }
}
